import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/icon_share.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-03153562")

_pushScopeId("data-v-03153562")
const _hoisted_1 = { class: "end" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: "https://yunyingcdn.thecover.cn/o_1hsn8kl5v1jcsjunc011pq7s8c9.gif",
  class: "end-img",
  alt: ""
}, null, -1)
const _hoisted_3 = { class: "notice" }
const _hoisted_4 = { class: "score" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 分享成绩")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", null, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.notice), 1)
    ]),
    _createVNode("div", _hoisted_4, "成绩：" + _toDisplayString(_ctx.score || 0) + "分", 1),
    (_ctx.activityData.templateConfig.sharePosterBg && _ctx.isShareImage)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "share",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleShare && _ctx.handleShare(...args)))
        }, [
          _hoisted_5,
          _hoisted_6
        ]))
      : _createCommentVNode("", true)
  ]))
})